import React, { useEffect } from 'react'

// global components
import Header from 'components/Header'
import Footer from 'components/Footer'
import Whatsapp from 'components/Whatsapp'

function TrocasDevolucoes() {
  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = 'LB STORE - Política de Trocas, Devoluções e Garantia'
  }, [])

  return (
    <div className='flex min-h-screen w-full flex-col bg-white text-gray-800'>
      <Header />

      <main className='mt-20 flex-grow px-6 py-12 md:py-16'>
        <div className='mx-auto w-full max-w-5xl'>
          {/* Header */}
          <header className='mb-10'>
            <h1 className='mb-6 text-4xl font-light tracking-wide text-gray-900 md:text-5xl'>
              Política de Troca, Devolução e Garantia
            </h1>
            <div className='mt-4 h-[2px] w-24 rounded bg-[#491C47]' />
          </header>

          <div className='space-y-12 leading-relaxed text-gray-700'>
            {/* Introdução */}
            <section>
              <p>
                A <strong>LB STORE</strong> preza pela sua satisfação e confiança. Por isso, criamos uma política de
                troca, devolução e garantia clara e alinhada ao Código de Defesa do Consumidor (CDC). Em caso de dúvida,
                entre em contato com nossa equipe antes de finalizar sua compra pelo{' '}
                <strong>WhatsApp (43) 99616-0770</strong>.
              </p>
            </section>

            {/* TROCAS */}
            <section>
              <h2 className='mb-3 text-2xl font-semibold text-gray-900'>Condições para Troca</h2>
              <p>
                Para realizar uma troca, o produto deve estar em perfeito estado, sem sinais de uso, danos ou
                modificações, e na embalagem original. A solicitação deve ser feita em até{' '}
                <strong>7 dias corridos </strong>
                após o recebimento da mercadoria, diretamente pelo nosso
                <strong> WhatsApp (43) 99616-0770</strong>.
              </p>
              <ul className='mt-3 list-disc space-y-2 pl-6'>
                <li>O produto deve estar novo, sem vestígios de uso;</li>
                <li>Deve acompanhar a nota fiscal e todos os acessórios recebidos;</li>
                <li>A etiqueta deve estar intacta e afixada à peça;</li>
                <li>
                  Solicitações fora do prazo de 7 dias ficam a critério de análise da equipe
                  <strong> LB STORE</strong>.
                </li>
              </ul>

              <p className='mt-4'>
                Após recebermos o produto e confirmarmos as condições, enviaremos um
                <strong> vale-troca</strong> para que você possa escolher novas peças de igual valor no catálogo. O
                valor do frete não é reembolsável.
              </p>
            </section>

            {/* ENVIO */}
            <section>
              <h2 className='mb-3 text-2xl font-semibold text-gray-900'>Como enviar seu produto para troca</h2>
              <p>
                Após o atendimento via WhatsApp, você receberá um
                <strong> código de postagem dos Correios </strong>
                para envio do produto. O frete da primeira troca é custeado pela
                <strong> LB STORE</strong>.
              </p>
              <p className='mt-2'>
                Utilize a embalagem original (caso esteja em boas condições) ou outra que proteja bem as peças durante o
                transporte.
              </p>
            </section>

            {/* REEMBOLSO */}
            <section>
              <h2 className='mb-3 text-2xl font-semibold text-gray-900'>Reembolso</h2>
              <p>O reembolso será feito conforme o método de pagamento utilizado na compra:</p>
              <ul className='mt-3 list-disc space-y-2 pl-6'>
                <li>
                  <strong>Cartão de crédito:</strong> estorno em até 7 dias após confirmação da devolução;
                </li>
                <li>
                  <strong>PIX ou boleto:</strong> devolução via depósito em conta indicada pelo cliente.
                </li>
              </ul>
              <p className='mt-3 text-sm text-gray-600'>
                O prazo para o valor aparecer na fatura pode variar conforme a operadora do cartão, podendo levar até 60
                dias.
              </p>
            </section>

            {/* GARANTIA */}
            <section>
              <h2 className='mb-3 text-2xl font-semibold text-gray-900'>Garantia de Fábrica</h2>
              <p>
                As semijoias LB STORE possuem <strong>garantia de 1 ano </strong>
                contra defeitos de fabricação e banho. Essa garantia cobre apenas falhas técnicas e não se aplica a
                desgastes naturais ou danos causados por mau uso.
              </p>
              <ul className='mt-3 list-disc space-y-2 pl-6'>
                <li>Evite contato com perfumes, cremes e produtos químicos;</li>
                <li>Não utilize as peças em praia, piscina ou durante o banho;</li>
                <li>As pedras não devem ser lavadas com detergente ou sabonete;</li>
                <li>Não garantimos quebra, arranhões, perda de pedras ou desgaste natural pelo uso.</li>
              </ul>
              <p className='mt-4'>
                Quando for comprovado o defeito de fabricação, a peça será
                <strong> consertada, rebanhada ou substituída</strong> sem custo adicional.
              </p>
              <p>
                Para acionar a garantia, fale diretamente com nossa equipe pelo{' '}
                <strong>WhatsApp (43) 99616-0770</strong>.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  )
}

export default TrocasDevolucoes
